export default "__VITE_ASSET__DREIZR27__"